import AddBeneficiaryError from './AddBeneficiaryError';
class InvalidRelationship extends AddBeneficiaryError {
    constructor(options) {
        super('The relationship value is not valid', options);
    }
}
export default InvalidRelationship;
